import type { ReactNode } from 'react';
import { cn } from './cn';

const tones = {
  neutral: 'bg-surface-2 text-fg-muted',
  brand: 'bg-brand-500/15 text-brand-300',
  success: 'bg-emerald-500/10 text-emerald-300 light:text-emerald-700',
  warning: 'bg-amber-500/10 text-amber-300 light:text-amber-700',
  danger: 'bg-red-500/10 text-red-300 light:text-red-700',
} as const;

export type BadgeTone = keyof typeof tones;

export function Badge({
  tone = 'neutral',
  children,
  className,
}: {
  tone?: BadgeTone;
  children: ReactNode;
  className?: string;
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-medium',
        tones[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}
